export default "__VITE_ASSET__DFGUfTix__"